import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@material-ui/core'
import React, { FC } from 'react'

import RoundButton from '@deltek/specification-client/core/Buttons/RoundButton'
import useStyles, {
    buttonSecondary,
    defaultLight,
} from './ProductHistoryModal.styles'
import ProductHistoryTable from './ProductHistoryTable'
import ProductInfoHeader from './ProductInfoHeader'

type ProductHistoryModalProps = {
    open: boolean
    listing: any
    onClose: () => void
}

const ProductHistoryModal: FC<ProductHistoryModalProps> = ({
    open,
    listing,
    onClose,
}) => {
    const classes = useStyles()

    return (
        <Dialog open={open} className={classes.dialogContainer} maxWidth="lg">
            <DialogTitle className={classes.dialogTitle}>
                Product History
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <ProductInfoHeader {...listing} />
                <ProductHistoryTable listingId={listing?.listingId} />
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <RoundButton
                    hasShadow={false}
                    borderColor={buttonSecondary}
                    color={buttonSecondary}
                    backgroundColor={defaultLight}
                    data-testid="productHistoryModalClose"
                    onClick={onClose}
                >
                    Close
                </RoundButton>
            </DialogActions>
        </Dialog>
    )
}

export default ProductHistoryModal
